import React from 'react'

const ContentSection = ({
  markdown_content,
  className,
  image = null,
  id = '',
  image_alt = ''
}) =>
  markdown_content && markdown_content.length > 10 ? (
    <section id={id} className={`section content-box ${className}`}>
      {image && <img className="section_image" src={image} alt={image_alt} />}
      <div
        dangerouslySetInnerHTML={{
          __html: markdown_content
        }}
      />
    </section>
  ) : (
    <></>
  )

export default ContentSection
